import { i18n } from './i18n';

export const paymentTypeToShow = (paymentType?: string | 'ACH' | 'CREDIT_CARD'): string => {
  switch (paymentType) {
    case 'ACH':
      return i18n.t('donation.payment_method_ach');
    case 'CREDIT_CARD':
      return i18n.t('donation.payment_method_card');
    default:
      return i18n.t('donation.payment_method_unknown');
  }
};
